import { useLookupFondsQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import { Fragment } from "react/jsx-runtime";
import './FondsCharts.scss'
import FondPersoBarChart from "../Fonds/FondPersoBarChart";
function FondPersosCharts() {
  const { data, error, isLoading } = useLookupFondsQuery({r:{perso:1}});
  const {translate}=useTrads();

  return (
    error ? (
        <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

    ) : isLoading ? (
        <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> 
    ) : data ? (
    
      <div>
        <h3>Fonds Perso</h3>
      <div className="chart-grid">
        
        {data.data.map(fond=>(
          <Fragment key={fond.id}>
          {(fond.solde>0)?
            <div  className="p-2">
             
              <FondPersoBarChart fond={fond} />
            </div>
          :null}
          </Fragment>
        )
        )}
      </div>
      </div>
    
    ):null
  );
}

export default FondPersosCharts;